export default "__VITE_ASSET__wxZTFAqN__"